import createAxiosInstance from 'helpers/create-axios-instance'

export const sinaClient = createAxiosInstance({timeout: 10000})
export const proxyClient = createAxiosInstance({timeout: 10000})
export const apiClient = createAxiosInstance({timeout: 5000})
export const decodeClient = createAxiosInstance({timeout: 10000})
export const appClient = createAxiosInstance({
  header: {clienttype: 'web'},
  timeout: 10000
})

export const accumulateClient = createAxiosInstance({timeout: 10000})

export const stockStatisticsClient = createAxiosInstance({timeout: 10000})



// WEBPACK FOOTER //
// ./src/plugins/stock/client.js